import React, { useEffect, useState } from "react";
import { Button, Grid, Stack, Box, Typography } from "@mui/material";
import Selector from "../Selector";
import { OutlinedInput, Select, MenuItem } from "@mui/material";
import { currencyOptions } from "../../constants";
import { EXCHANGE_RATE_URL } from "../../constants";
import axios from "axios";

const CurrencyInput = ({
	label,
	currency,
	placeholder,
	formik,
	name,
	setCurrency,
}) => {
	

	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "flex-start",
				border: "1px solid lightgrey",
				borderRadius: "30px",
			}}
		>
			<Box>
				<Select
					labelId="demo-simple-select-label"
					id="demo-simple-select"
					name="currency"
					value={formik.values.currency}
					label="Age"
					fullWidth
					onChange={formik.handleChange}
					sx={{
						border: "none !important",
						"& .MuiOutlinedInput-notchedOutline": {
							border: "none !important",
							borderRight: "1px solid lightgrey !important",
							borderRadius: 0,
						},
					}}
				>
					{currencyOptions?.map((currency, index) => (
						<MenuItem key={index} value={currency?.value}>
							{currency?.label}
						</MenuItem>
					))}
				</Select>
			</Box>
			<Box sx={{ flexGrow: 1 }}>
				<OutlinedInput
					placeholder={placeholder}
					id={name}
					sx={{
						border: "none !important",
						"& .MuiOutlinedInput-notchedOutline": {
							border: "none !important",
						},
					}}
					fullWidth
					name={name}
					value={formik.values?.[name]}
					type="number"
					step="0.01"
					onChange={formik.handleChange}
				/>
			</Box>
		</Box>
	);
};

export default CurrencyInput;
